import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { commandNameMap } from '../../utils/textMappings';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import { WeightAlertGroupRecord } from '../../Interfaces/Alerts/AlertRecord';
import {
  SplitButton,
  SplitButtonItemClickEvent,
  SplitButtonClickEvent,
} from '@progress/kendo-react-buttons';

const useStyles = makeStyles(theme => ({
  root: {},
}));
import { GetString } from '../StringResourceManager';

export default function SplitButtonByAlert(props: {
  alertRecord: WeightAlertGroupRecord;

  handleDialog: (
    alertRecord: WeightAlertGroupRecord,
    command: ApiEnums.AlertCommand
  ) => void;

  handleButtonClick: (
    alertRecord: WeightAlertGroupRecord,
    command: ApiEnums.AlertCommand
  ) => void;
}): JSX.Element {
  const classes = useStyles();

  const handleButtonClick = (event: SplitButtonClickEvent) => {
    props.handleButtonClick(
      props.alertRecord,
      props.alertRecord.RecommendedCommand
    );
  };

  const handleMenuItemClick = (event: SplitButtonItemClickEvent) => {
    props.handleButtonClick(
      props.alertRecord,
      props.alertRecord.SupportedCommands[event.itemIndex]
    );
  };

  return (
    <React.Fragment>
      <SplitButton
        className={classes.root}
        disabled={
          props.alertRecord.CommandStatus !== ApiEnums.CommandStatus.New
        }
        text={GetString(commandNameMap(props.alertRecord.SelectedCommand))}
        onButtonClick={handleButtonClick}
        onItemClick={handleMenuItemClick}
        items={props.alertRecord.SupportedCommands.map((option, index) =>
          GetString(commandNameMap(option))
        )}
      />
    </React.Fragment>
  );
}
